export interface ArticleAnchor {
  number: number;
  id: string;
  text: string;
}

const ART_RE = /^\s*Art(?:[íi]culo|\.)?\s*(\d+)\b/i;

export function annotateArticles(container: HTMLElement): ArticleAnchor[] {
  const anchors: ArticleAnchor[] = [];
  const seen = new Set<number>();
  const paragraphs = container.querySelectorAll('p, div, h2, h3, h4, li, span, strong, b');
  paragraphs.forEach((node) => {
    const el = node as HTMLElement;
    if (el.children.length > 2 && !['P', 'DIV'].includes(el.tagName)) return; // Evitar contenedores grandes
    const text = (el.textContent ?? '').trim();
    if (!text) return;
    const m = text.match(ART_RE);
    if (!m) return;
    const num = Number(m[1]);
    if (seen.has(num)) return;
    seen.add(num);
    const id = `art-${num}`;
    if (!el.id) el.id = id;
    el.classList.add('articulo');
    anchors.push({ number: num, id, text: text.slice(0, 140) });
  });
  return anchors.sort((a, b) => a.number - b.number);
}

export function extractTitle(container: HTMLElement): string | undefined {
  const h1 = container.querySelector('h1, h2');
  if (h1) return (h1.textContent ?? '').trim() || undefined;
  const firstStrong = container.querySelector('strong, b');
  if (firstStrong) return (firstStrong.textContent ?? '').trim() || undefined;
  return undefined;
}
